import { inject, PLATFORM_ID } from '@angular/core'
import { CanActivateFn, Router, ActivatedRouteSnapshot } from '@angular/router'
import { Store } from '@ngrx/store'
import { combineLatest, map, take, tap } from 'rxjs'
import { selectUser, selectUserPermissions } from '../store/auth/auth.selectors'
import { eps } from '../services/url.service'
import { selectUserRoles } from '../store/user/user.selectors'
import { getStoredPermissions } from '../utils/permission.helper'
import { isPlatformBrowser } from '@angular/common'
type PermissionItem = {
  moduleName: string
  permissions: string[]
  scope?: any[]
}
export const permissionGuard: CanActivateFn = (route: ActivatedRouteSnapshot) => {
  const platformId = inject(PLATFORM_ID)

  // ✅ Server pe block mat karo, client pe hi real check chalega
  if (!isPlatformBrowser(platformId)) {
    return true
  }
  const router = inject(Router)
  const store = inject(Store)

  // Expected context passed in route data or elsewhere
  const contextBusinessId = route.data['businessId'] as string | undefined
  const contextOfficeId = route.data['officeId'] as string | undefined

  //   return combineLatest([
  //     store.select(selectUserPermissions), // as before: map entity -> permission array
  //     store.select(selectUserRoles) // new selector: provides user roles with businessId and officeId
  //   ]).pipe(
  //     take(1),
  //     map(([userPermissions, userRoles]) => {
  //       const permissionsData = route.data['permissions'] as
  //         | Record<string, string[]> // AND
  //         | Record<string, string[]>[] // OR
  //         | undefined

  //       // Filter userRoles based on context if context is provided
  //       //   const filteredRoles = userRoles?.filter(role => {
  //       //     if (contextBusinessId && role.businessId !== contextBusinessId) {
  //       //       return false
  //       //     }
  //       //     if (contextOfficeId && role.officeId !== contextOfficeId) {
  //       //       return false
  //       //     }
  //       //     return true
  //       //   })
  //       const filteredRoles = (userRoles ?? []).filter(role => {
  //         if (contextBusinessId && role.businessId !== contextBusinessId) {
  //           return false
  //         }
  //         if (contextOfficeId && role.officeId !== contextOfficeId) {
  //           return false
  //         }
  //         return true
  //       })

  //       // Aggregate permissions only from the filtered roles
  //       let filteredUserPermissions: Record<string, string[]> = {}

  //       for (const role of filteredRoles) {
  //         for (const [entity, actions] of Object.entries(role.permissions)) {
  //           if (!filteredUserPermissions[entity]) {
  //             filteredUserPermissions[entity] = []
  //           }
  //           // Merge unique actions
  //           actions.forEach(action => {
  //             if (!filteredUserPermissions[entity].includes(action)) {
  //               filteredUserPermissions[entity].push(action)
  //             }
  //           })
  //         }
  //       }

  //       const checkPermission = (entity: string, actions: string[]) =>
  //         actions.every(action => filteredUserPermissions[entity]?.includes(action))

  //       let hasPermission = false
  //       console.log('permission data, permission guard', permissionsData)
  //       if (Array.isArray(permissionsData)) {
  //         // OR logic → at least one set must match
  //         hasPermission = permissionsData.some(permissionSet =>
  //           Object.entries(permissionSet).every(([entity, actions]) =>
  //             checkPermission(entity, actions)
  //           )
  //         )
  //       } else if (permissionsData && typeof permissionsData === 'object') {
  //         // AND logic → all must match
  //         hasPermission = Object.entries(permissionsData).every(([entity, actions]) =>
  //           checkPermission(entity, actions)
  //         )
  //       } else {
  //         hasPermission = true // no permissions required
  //       }

  //       if (!hasPermission) {
  //         router.navigate([eps.user.unauthorizedPath])
  //       }

  //       return hasPermission
  //     })
  //   )

  //commented on 5 nov 2025
  // return store.select(selectUserPermissions).pipe(
  //   take(1),
  //   map(userPermissions => {
  //     const permissionsData = route.data['permissions'] as
  //       | Record<string, string[]>
  //       | Record<string, string[]>[]
  //       | undefined

  //     const checkPermission = (entity: string, actions: string[]) =>
  //       actions.every(action => userPermissions[entity]?.includes(action))

  //     let hasPermission = false
  //     if (Array.isArray(permissionsData)) {
  //       // OR logic → at least one set must match
  //       hasPermission = permissionsData.some(permissionSet =>
  //         Object.entries(permissionSet).every(([entity, actions]) =>
  //           checkPermission(entity, actions)
  //         )
  //       )
  //     } else if (permissionsData && typeof permissionsData === 'object') {
  //       const entities = Object.entries(permissionsData)

  //       if (entities.length > 1) {
  //         // OR logic → at least one entity must match
  //         hasPermission = entities.some(([entity, actions]) => checkPermission(entity, actions))
  //       } else {
  //         // Single object → AND logic (must match all actions)
  //         hasPermission = entities.every(([entity, actions]) => checkPermission(entity, actions))
  //       }
  //     } else {
  //       hasPermission = true // no permissions required
  //     }

  //     if (!hasPermission) {
  //       router.navigate([eps.user.unauthorizedPath])
  //     }

  //     return hasPermission
  //   })
  // )

  //5nov 2025
  // return store.select(selectUserPermissions).pipe(
  //   take(1),
  //   map(userPermissions => {
  //     const permissionsData = route.data['permissions'] as
  //       | Record<string, string[]>
  //       | Record<string, string[]>[]
  //       | undefined

  //     // Helper: check if user has *all* required actions for an entity
  //     const hasActions = (entity: string, actions: string[]) =>
  //       actions.every(action => userPermissions[entity]?.includes(action))

  //     // Final permission flag
  //     let hasPermission = true

  //     if (Array.isArray(permissionsData)) {
  //       // Array = OR between sets; within each set = AND
  //       hasPermission = permissionsData.some(permissionSet =>
  //         Object.entries(permissionSet).every(([entity, actions]) => hasActions(entity, actions))
  //       )
  //     } else if (permissionsData && typeof permissionsData === 'object') {
  //       // Single object = AND between all entities/actions
  //       hasPermission = Object.entries(permissionsData).every(([entity, actions]) =>
  //         hasActions(entity, actions)
  //       )
  //     }

  //     return hasPermission
  //   }),
  //   tap(hasPermission => {
  //     if (!hasPermission) {
  //       router.navigate([eps.user.unauthorizedPath])
  //     }
  //   })
  // )

  //7 may 2026
  // return store.select(selectUserPermissions).pipe(
  //   take(1),
  //   map(permissions => {
  //     const routePermissions = route.data['permissions'] as
  //       | Record<string, string[]>
  //       | Record<string, string[]>[]

  //     const hasActions = (module: string, actions: string[]) =>
  //       actions.every(a => permissions[module]?.includes(a))

  //     let hasPermission = true

  //     if (Array.isArray(routePermissions)) {
  //       hasPermission = routePermissions.some(set =>
  //         Object.entries(set).every(([module, actions]) => hasActions(module, actions))
  //       )
  //     } else {
  //       hasPermission = Object.entries(routePermissions || {}).every(([module, actions]) =>
  //         hasActions(module, actions)
  //       )
  //     }

  //     return hasPermission
  //   }),
  //   tap(hasPermission => {
  //     if (!hasPermission) {
  //       router.navigate([eps.user.unauthorizedPath])
  //     }
  //   })
  // )

  //debug
  // return store.select(selectUserPermissions).pipe(
  //   take(1),
  //   map(permissions => {
  //     const routePermissions = route.data['permissions'] as
  //       | Record<string, string[]>
  //       | Record<string, string[]>[]

  //     const routePath = route.routeConfig?.path || ''

  //     console.log('📍 ROUTE PATH:', routePath)
  //     console.log('🔐 USER PERMISSIONS:', permissions)
  //     console.log('📌 ROUTE PERMISSIONS:', routePermissions)

  //     // ✅ DASHBOARD SKIP
  //     if (routePath.includes('user/employeeDashboard')) {
  //       console.log('⚡ Dashboard route detected → skipping permission check')
  //       return true
  //     }

  //     const hasActions = (module: string, actions: string[]) => {
  //       const userActions = permissions[module] || []

  //       console.log('➡️ Checking Module:', module)
  //       console.log('   Required Actions:', actions)
  //       console.log('   User Actions:', userActions)

  //       const result = actions.every(a => userActions.includes(a))

  //       console.log('   Match Result:', result)

  //       return result
  //     }

  //     let hasPermission = true

  //     if (Array.isArray(routePermissions)) {
  //       hasPermission = routePermissions.some(set =>
  //         Object.entries(set).every(([module, actions]) => hasActions(module, actions as string[]))
  //       )
  //     } else {
  //       hasPermission = Object.entries(routePermissions || {}).every(([module, actions]) =>
  //         hasActions(module, actions as string[])
  //       )
  //     }

  //     console.log('🚦 FINAL HAS PERMISSION:', hasPermission)

  //     return hasPermission
  //   }),
  //   tap(hasPermission => {
  //     if (!hasPermission) {
  //       console.warn('⛔ ACCESS DENIED - Redirecting')
  //       router.navigate([eps.user.unauthorizedPath])
  //     }
  //   })
  // )

  // return store.select(selectUser).pipe(
  //   take(1),
  //   map(user => {
  //     const permissions = getStoredPermissions()

  //     const routePermissions = route.data['permissions'] as
  //       | Record<string, string[]>
  //       | Record<string, string[]>[]

  //     console.log('🔐 LOCAL PERMISSIONS:', permissions)
  //     console.log('📌 ROUTE PERMISSIONS:', routePermissions)
  //     const routePath = route.routeConfig?.path || ''
  //     if (routePath.includes('user/employeeDashboard')) {
  //       // console.log('⚡ Dashboard route detected → skipping permission check')
  //       return true
  //     }

  //     // 🔥 ADMIN BYPASS (OLD STYLE SAFE)
  //     const isAdmin = user?.userRoles?.some(
  //       role => role.name?.toLowerCase() === 'admin' && role.status === 'Active'
  //     )

  //     if (isAdmin) {
  //       // console.log('🔥 Admin bypass triggered')
  //       return true
  //     }

  //     const hasActions = (module: string, actions: string[]) => {
  //       const userActions = permissions[module] || []
  //       return actions.every(a => userActions.includes(a))
  //     }

  //     let hasPermission = true

  //     if (Array.isArray(routePermissions)) {
  //       hasPermission = routePermissions.some(set =>
  //         Object.entries(set).every(([module, actions]) => hasActions(module, actions as string[]))
  //       )
  //     } else {
  //       hasPermission = Object.entries(routePermissions || {}).every(([module, actions]) =>
  //         hasActions(module, actions as string[])
  //       )
  //     }

  //     // console.log('🚦 FINAL RESULT:', hasPermission)

  //     return hasPermission
  //   }),
  //   tap(hasPermission => {
  //     if (!hasPermission) {
  //       router.navigate([eps.user.unauthorizedPath])
  //     }
  //   })
  // )

  return store.select(selectUser).pipe(
    take(1),
    map(user => {
      const routePath = route.routeConfig?.path || ''

      // console.log('==============================')
      // console.log('📍 ROUTE CALLED:', routePath)
      // console.log('👤 USER:', user?.email || user?.id)
      // console.log('==============================')

      // 🔥 ADMIN BYPASS
      const isAdmin = user?.userRoles?.some(
        r => r?.role?.name?.toLowerCase() === 'admin' && r?.status === 'Active'
      )

      if (isAdmin) {
        // console.log('🔥 ADMIN BYPASS → ALLOWED')
        return true
      }

      // ===============================
      // 🔐 NORMALIZE PERMISSIONS
      // ===============================
      const raw = getStoredPermissions()

      const permissionsArr: PermissionItem[] = Array.isArray(raw) ? raw : []

      const permissions: Record<string, string[]> = permissionsArr.reduce(
        (acc, item) => {
          if (item?.moduleName) {
            acc[item.moduleName] = item.permissions || []
          }
          return acc
        },
        {} as Record<string, string[]>
      )

      // console.log('🔐 NORMALIZED PERMISSIONS:', permissions)

      // ===============================
      // 📌 ROUTE PERMISSIONS
      // ===============================
      const routePermissions = route.data['permissions'] as
        | Record<string, string[]>
        | Record<string, string[]>[]

      // console.log('📌 REQUIRED PERMISSIONS:', routePermissions)

      // ✅ DASHBOARD SKIP
      if (
        routePath.includes('user/employeeDashboard')
        // ||
        // routePath.includes('user/ownerDashboard')
      ) {
        // console.log('⚡ Dashboard route detected → skipping permission check')
        return true
      }

      // ===============================
      // 🔍 CHECK FUNCTION
      // ===============================
      const hasActions = (module: string, actions: string[]) => {
        const userActions = permissions[module] || []

        const result = actions.every(a => userActions.includes(a))

        // console.log(`➡️ Module: ${module}`)
        // console.log(`   Required:`, actions)
        // console.log(`   User has:`, userActions)
        // console.log(`   Match:`, result)

        return result
      }

      // ===============================
      // 🧠 PERMISSION LOGIC
      // ===============================
      let hasPermission = true

      if (Array.isArray(routePermissions)) {
        hasPermission = routePermissions.some(set =>
          Object.entries(set).every(([module, actions]) => hasActions(module, actions as string[]))
        )
      } else {
        hasPermission = Object.entries(routePermissions || {}).every(([module, actions]) =>
          hasActions(module, actions as string[])
        )
      }

      // console.log('🚦 FINAL RESULT:', hasPermission)
      // console.log('==============================')

      return hasPermission
    }),
    tap(hasPermission => {
      if (!hasPermission) {
        // console.warn('⛔ ACCESS DENIED → redirecting')
        router.navigate([eps.user.unauthorizedPath])
      }
    })
  )
}
